import { render } from "./ProdiDetail.vue?vue&type=template&id=3957eb12"
import script from "./ProdiDetail.vue?vue&type=script&lang=js"
export * from "./ProdiDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__